import { create } from 'zustand';

export type DrawerItemType = 'order' | 'klant';

export interface RoutePlannerDrawerOpenItem {
  type: DrawerItemType;
  id: string;
  klantType?: 'account' | 'lead'; // only used when type === 'klant'
}

interface RoutePlannerDrawerState {
  openItem: RoutePlannerDrawerOpenItem | null;
  open: (item: RoutePlannerDrawerOpenItem) => void;
  close: () => void;
}

export const useRoutePlannerDrawerStore = create<RoutePlannerDrawerState>((set) => ({
  openItem: null,
  open: (item) => set({ openItem: item }),
  close: () => set({ openItem: null }),
}));

/** Encode drawer state for the `?open=` query param. */
export function encodeDrawerParam(item: RoutePlannerDrawerOpenItem | null): string | null {
  if (!item) return null;
  return `${item.type}:${item.id}`;
}

/** Parse the `?open=` query param (+ optional klantType) back into drawer state. */
export function parseDrawerParam(
  raw: string | null,
  klantType: string | null,
): RoutePlannerDrawerOpenItem | null {
  if (!raw) return null;
  const [type, ...rest] = raw.split(':');
  const id = rest.join(':');
  if (!id) return null;
  if (type === 'order') return { type, id };
  if (type === 'klant') {
    const kt = klantType === 'lead' ? 'lead' : 'account';
    return { type, id, klantType: kt };
  }
  return null;
}
